module.exports = __webpack_public_path__ + "8a5356e9/img/verified-icon.f93bbc14.svg";